import PropTypes from 'prop-types';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';

const AutoCheckout = ({ checkoutSetting, checkoutMinutes, handleUpdate }) => (
  <Formik
    initialValues={{
      autoCheckOut: checkoutSetting,
      autoCheckOutMinutes: checkoutMinutes,
    }}
    enableReinitialize
    validationSchema={Yup.object({
      autoCheckOut: Yup.boolean(),
      autoCheckOutMinutes: Yup.number().when('autoCheckOut', {
        is: true,
        then: Yup.number()
          .typeError('Auto Checkout minutes must be greater than or equal to 2')
          .positive()
          .required('Please enter your auto logout time')
          .min(2, 'Auto Checkout minutes must be greater than or equal to 2'),
      }),
    })}
    onSubmit={(values) => {
      if (values.autoCheckOut === false) {
        values.autoCheckOutMinutes = '';
      }

      handleUpdate(values);
    }}
  >
    {(formikprops) => (
      <div className="col-12 col-md-12">
        <Form onSubmit={formikprops.handleSubmit} className="needs-validation">
          <Card>
            <Card.Body>
              <h6 className="text-uppercase text-muted mb-2">
                Auto Checkout Settings
              </h6>
              <Row>
                <Col>
                  <div className="form-check ">
                    <Field
                      className="form-check-input form-check-border"
                      name="autoCheckOut"
                      type="checkbox"
                      onChange={(e) => {
                        formikprops.setFieldValue(
                          'autoCheckOut',
                          !formikprops.values.autoCheckOut
                        );
                        if (
                          !e.target.checked &&
                          e.target.checked !== checkoutSetting
                        ) {
                          handleUpdate({
                            autoCheckOut: false,
                            autoCheckOutMinutes: 0,
                          });
                        }
                      }}
                      checked={formikprops.values.autoCheckOut}
                    />
                    <Form.Label className="form-check-label ">
                      Enable auto checkout from project
                    </Form.Label>
                  </div>
                </Col>

                <Col>
                  {formikprops.values.autoCheckOut && (
                    <Field
                      className="form-control"
                      type="text"
                      placeholder="Idle time in minutes"
                      name="autoCheckOutMinutes"
                    />
                  )}

                  <ErrorMessage
                    name="autoCheckOutMinutes"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Col>
                <Col md="auto">
                  <Button
                    type="submit"
                    disabled={!(formikprops.isValid && formikprops.dirty)}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Form>
      </div>
    )}
  </Formik>
);
AutoCheckout.propTypes = {
  checkoutSetting: PropTypes.bool,
  checkoutMinutes: PropTypes.any,
  handleUpdate: PropTypes.func,
};
export default AutoCheckout;
